import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["Image"] */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/(frontend)/entreprises/[slug]/CompanyDetail.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/(frontend)/entreprises/[slug]/mises-en-page/carte-publique.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/(frontend)/entreprises/[slug]/mises-en-page/detail-repliable.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default","PanneauProjet"] */ "/vercel/path0/src/app/(frontend)/entreprises/[slug]/mises-en-page/explorateur.tsx");
